export default Object.freeze({
    EventKeys: {
        // AI
        AI: "AI",
        Chat: "Chat",
    },
});
